import ClinicalAnnotationsBarChart from 'components/ClinicalAnnotation/BarChart';
import Loading from 'components/Loading';
import KyError from 'components/errors/KyError';
import {useGet} from 'helpers/KyHooks';

export default function ClinicalAnnotationSection() {
  const {response, error} = useGet('site/clinicalAnnotations/overview', {cacheResponse: true});

  let content = <div className="caFigure caFigure--loading figure"><Loading /></div>;

  if (response) {
    content = (
      <ClinicalAnnotationsBarChart
        pgxLevels={response?.data}
      />
    );
  } else if (error) {
    content = <KyError kyError={error} />;
  }
  
  return (
    <div id="section-ca">
      <h3>Summary Annotations</h3>
      {content}
    </div>
  );
}
